import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import AllProjects from "../components/projects/allProjects";
import AboutBuilder from "../components/common/aboutBuilder";

import INFO from "../data/user";
import SEO from "../data/seo";
import { PROJECT_CATEGORIES } from "../data/featured-projects";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	const [category, setCategory] = useState("Featured");

	// Live demos before repo-only cards; Array.sort is stable, so array order holds otherwise.
	const liveFirst = (list) =>
		[...list].sort((a, b) => (b.liveLink ? 1 : 0) - (a.liveLink ? 1 : 0));

	// "All" is sectioned by each card's first category so the full list stays scannable.
	const sections =
		category === "All"
			? PROJECT_CATEGORIES.map((c) => ({
					name: c,
					projects: liveFirst(
						INFO.projects.filter((p) => (p.categories || [])[0] === c)
					),
			  })).filter((s) => s.projects.length > 0)
			: [
					{
						name: null,
						projects:
							category === "Featured"
								? INFO.projects.filter((p) => p.featured)
								: liveFirst(
										INFO.projects.filter((p) =>
											(p.categories || []).includes(category)
										)
								  ),
					},
			  ];
	const isEmpty = sections.every((s) => s.projects.length === 0);

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title animate-fade-up">
							Building Solutions That Scale
						</div>

						<div className="subtitle projects-subtitle animate-fade-up animate-delay-200">
							AI and developer tools I designed and shipped.
							<br />
							Some run entirely in your browser, others are open source.
							<br />
							Each card links to a live demo, the code, or both.
						</div>

						<div className="projects-filter">
							{["Featured", "All", ...PROJECT_CATEGORIES].map((c) => (
								<button
									key={c}
									className={`projects-chip${
										category === c ? " active" : ""
									}`}
									onClick={() => setCategory(c)}
								>
									{c}
								</button>
							))}
						</div>

						<div className="projects-list">
							<div className="github-projects-section">
								{isEmpty ? (
									<div className="projects-empty">
										No projects in this category yet.
									</div>
								) : (
									sections.map((s) => (
										<section
											key={s.name || category}
											className="projects-section"
										>
											{s.name && (
												<h2 className="projects-section-title">
													{s.name}
													<span className="projects-section-count">
														{s.projects.length}
													</span>
												</h2>
											)}
											<AllProjects projects={s.projects} />
										</section>
									))
								)}
								{category === "Featured" && (
									<div className="projects-see-all">
										<button
											className="projects-chip"
											onClick={() => setCategory("All")}
										>
											See all {INFO.projects.length} projects
										</button>
									</div>
								)}
							</div>
						</div>

						<AboutBuilder />
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
